











import Vue from 'vue';
import { Route } from 'vue-router';
import AppNavigation from './AppNavigation.vue';

export default Vue.extend({
  name: 'App',
  components: {
    AppNavigation,
  },
  data() {
    return {
      transitionName: 'slide-y-fade',
      showExtended: true,
    };
  },
});
